import { css } from '@emotion/css';

const wrapper = css`
  margin-bottom: var(--spacings-2);
`;

const selector = css`
  width: 100%;
  max-width: 300px;
  padding: 0;

  & #currency {
    display: flex;
    padding: var(--spacings-2);
    align-items: center;
  }
`;

const CurrencySelectorStyles = {
  wrapper,
  selector,
};

export default CurrencySelectorStyles;
